import React from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import BoxWithIcon from "../atoms/ComponentBox/BoxWithIcon";
import { useLocation ,useNavigate} from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectPermissions } from '../redux/permissionsSlice';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const Maintenance = () => {
  const names = ['Paste Control', 'Heat Pump', 'Air Conditioner', 
                 'Meter Reading', 'Fire System', 'Room PPM', 'AC Meter Reading'];

                 const location = useLocation();
  const navigate = useNavigate();
  const permissions = useSelector(selectPermissions);
  const hasModulePermission = (moduleName) => {
    const modulePermission = permissions.find(
      permission => permission.ModuleName === moduleName
    );
    
    if (!modulePermission) return false;

    return (
      modulePermission.AddRec === "1" ||
      modulePermission.EditRec === "1" ||
      modulePermission.DeleteRec === "1" ||
      modulePermission.ViewRec === "1"
    );
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container>
        <Grid item xs={12}>
          <Grid container spacing={2}>
          {hasModulePermission("Paste Control") && (
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link="#"
              // link={{ pathname: '/' }}
              title="Paste Control"
            />)}

           {hasModulePermission("Heat Pump") && (
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link="#"
              // link={{ pathname: '/' }}
              title="Heat Pump"
            />)}

           {hasModulePermission("Air Conditioner") && (
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link="#"
              // link={{ pathname: '/' }}
              title="Air Conditioner"
            />)}


            {hasModulePermission("Meter Reading") && (
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link="#"
              // link={{ pathname: '/' }}
              title="Meter Reading"
            />)}

           {hasModulePermission("Fire System") && (
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link="#"
              // link={{ pathname: '/' }}
              title="Fire System"
            />)}

          {hasModulePermission("Room PPM") && (
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link="#"
              // link={{ pathname: '/' }}
              title="Room PPM"
            />)}

          {hasModulePermission("AC Meter Reading") && (
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link="#"
              // link={{ pathname: '/' }}
              title="AC Meter Reading"
            />)}
          </Grid>
          <Grid container spacing={2} sx={{ mt: 1 }}>  
         
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Maintenance;